export default __webpack_public_path__ + "static/media/18.02e5c838.png";